var _path, _polygon, _linearGradient, _path2, _linearGradient2, _path3, _linearGradient3, _polygon2, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _path6, _linearGradient7, _polygon3, _linearGradient8, _polygon4, _linearGradient9, _path7, _linearGradient10, _polygon5, _linearGradient11, _path8, _linearGradient12, _polygon6, _linearGradient13, _path9, _linearGradient14, _path10, _linearGradient15, _path11, _polygon7, _linearGradient16, _polygon8, _linearGradient17, _path12, _linearGradient18, _polygon9, _linearGradient19, _path13, _linearGradient20, _polygon10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNetlify(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.961,11.954l-0.017-0.007l0.049,0.049C24.014,11.996,23.961,11.954,23.961,11.954z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "23.272 12.518 23.272 12.562 23.366 12.602"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -1830.001,
    x2: -1829.001,
    y1: -1809.456,
    y2: -1809.456,
    gradientTransform: "matrix(0 20.6284 20.6284 0 37340.602 37752.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M16.159,8.413l0.575-3.562L14.6,2.609l-2.511,3.864v0.054c0.108,0.163,0.184,0.359,0.208,0.57l0.001,0.006l3.505,1.487c0.102-0.079,0.22-0.139,0.35-0.176L16.159,8.413z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -1830.001,
    x2: -1829.001,
    y1: -1809.456,
    y2: -1809.456,
    gradientTransform: "matrix(0 20.6284 20.6284 0 37345.875 37752.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M23.327,12.604l-5.934-2.537c-0.166,0.22-0.414,0.37-0.696,0.407l-0.005,0.001l-0.648,3.971c0.187,0.188,0.303,0.447,0.304,0.733l3.642,0.765l3.338-3.321V12.604z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -1830.001,
    x2: -1829.001,
    y1: -1809.456,
    y2: -1809.456,
    gradientTransform: "matrix(0 20.6284 20.6284 0 37347.059 37752.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#c)",
    points: "20.293 8.276 17.738 9.324 24 11.987"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -1830.001,
    x2: -1829.001,
    y1: -1809.364,
    y2: -1809.364,
    gradientTransform: "matrix(0 20.6284 20.6284 0 37338.016 37752.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M12.161,7.846C12.114,7.917,12.06,7.983,12,8.042v2.893l3.445-1.495l-0.003-0.074l0.004-0.088v0.004l0.001-0.009L15.437,9.24L12.161,7.846L12.161,7.846z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -1830.001,
    x2: -1829.001,
    y1: -1809.456,
    y2: -1809.456,
    gradientTransform: "matrix(0 20.6284 20.6284 0 37343.398 37752.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M16.21,15.913c-0.119,0.151-0.274,0.271-0.454,0.343l-0.007,0.003l-0.763,4.736l4.447-4.411l-0.021,0.02v-0.03L16.21,15.913z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -1830.001,
    x2: -1829.001,
    y1: -1809.456,
    y2: -1809.456,
    gradientTransform: "matrix(0 20.6284 20.6284 0 37344.477 37752.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M16.974,8.507c0.118,0.061,0.219,0.138,0.303,0.23l0.001,0.001l2.354-1.049l-2.197-2.179l-0.491,2.964L16.974,8.507z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -1830.001,
    x2: -1829.001,
    y1: -1809.456,
    y2: -1809.456,
    gradientTransform: "matrix(0 20.6284 20.6284 0 37341.637 37752.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#g)",
    points: "15.446 9.439 15.445 9.439 15.446 9.449"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -1830.001,
    x2: -1829.001,
    y1: -1809.289,
    y2: -1809.289,
    gradientTransform: "matrix(0 20.6284 20.6284 0 37335.293 37752.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#h)",
    points: "12 21.233 12 23.9 13.092 22.817 12 21.233"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -1830.001,
    x2: -1829.001,
    y1: -1809.368,
    y2: -1809.368,
    gradientTransform: "matrix(0 20.6284 20.6284 0 37338.293 37752.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M15.698,10.256L12,11.842v2.472l2.369,0.489c0.17-0.294,0.472-0.495,0.822-0.524h0.004l0.639-3.907L15.698,10.256L15.698,10.256z"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -1830.001,
    x2: -1829.001,
    y1: -1809.335,
    y2: -1809.335,
    gradientTransform: "matrix(0 20.6284 20.6284 0 37336.727 37752.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#j)",
    points: "12 .049 12 5.292 14.044 2.095 12 .049"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: -1830.001,
    x2: -1829.001,
    y1: -1809.365,
    y2: -1809.365,
    gradientTransform: "matrix(0 20.6284 20.6284 0 37337.79 37752.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M12,15.06v4.793l1.678,2.431l0.324-0.326l0.921-5.689l0.01,0.008v-0.028c-0.305-0.127-0.533-0.387-0.615-0.705l-0.002-0.007L12,15.06L12,15.06z"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: -1830.001,
    x2: -1829.001,
    y1: -1809.456,
    y2: -1809.456,
    gradientTransform: "matrix(0 20.6284 20.6284 0 37329.234 37752.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32ab9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4786aa"
  }))), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#l)",
    points: ".534 12.737 2.742 14.98 5.526 13.796 5.556 13.787 .534 12.737"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: -1830.001,
    x2: -1829.001,
    y1: -1809.456,
    y2: -1809.456,
    gradientTransform: "matrix(0 20.6284 20.6284 0 37333.148 37752.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32ab9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4786aa"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M6.467,5.417L3.789,8.026l2.939,4.294l0.157-0.007l0.165,0.008L7.044,12.32l0.172-0.012l0.18,0.012L7.389,12.32l2.741-4.265C9.924,7.842,9.796,7.55,9.795,7.229L9.788,7.093l0.008-0.141L9.795,6.958L6.467,5.417L6.467,5.417z"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: -1830.001,
    x2: -1829.001,
    y1: -1809.456,
    y2: -1809.456,
    gradientTransform: "matrix(0 20.6284 20.6284 0 37329.219 37752.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32ab9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4786aa"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M6.061,12.748c0,0-0.001,0.001-0.001,0.001l0,0L6.061,12.748L6.061,12.748z M3.286,8.602L0,11.796l5.818,1.289h0.002c0.069-0.127,0.149-0.237,0.241-0.335L3.286,8.602L3.286,8.602z"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: -1830.001,
    x2: -1829.001,
    y1: -1809.539,
    y2: -1809.539,
    gradientTransform: "matrix(0 20.6284 20.6284 0 37338.016 37752.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32ab9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4786aa"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M12,8.042c-0.219,0.217-0.517,0.349-0.847,0.349l-0.041-0.001h-0.198l-2.711,4.192L12,10.935V8.042L12,8.042z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#DEDEDE",
    points: "12 23.9 11.899 24 12 24 12 23.9"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: -1830.001,
    x2: -1829.001,
    y1: -1809.456,
    y2: -1809.456,
    gradientTransform: "matrix(0 20.6284 20.6284 0 37330.848 37752.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32ab9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4786aa"
  }))), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#p)",
    points: "5.882 14.446 3.339 15.494 4.574 16.72 5.975 14.541 5.882 14.446"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: -1830.001,
    x2: -1829.001,
    y1: -1809.482,
    y2: -1809.482,
    gradientTransform: "matrix(0 20.6284 20.6284 0 37335.293 37752.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32ab9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4786aa"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M6.655,15.02c0.003,0.001,0.007,0.002,0.01,0.003l0-0.001L6.655,15.02L6.655,15.02z M7.681,14.97c-0.165,0.079-0.359,0.125-0.564,0.126H7.11c-0.155,0-0.305-0.026-0.445-0.073l-1.547,2.252L11.899,24L12,23.9v-2.666L7.681,14.97L7.681,14.97z"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: -1830.001,
    x2: -1829.001,
    y1: -1809.549,
    y2: -1809.549,
    gradientTransform: "matrix(0 20.6284 20.6284 0 37338.293 37752.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32ab9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4786aa"
  }))), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#r)",
    points: "12 11.842 8.373 13.398 8.472 13.576 8.476 13.588 12 14.314 12 11.842"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: -1830.001,
    x2: -1829.001,
    y1: -1809.505,
    y2: -1809.505,
    gradientTransform: "matrix(0 20.6284 20.6284 0 37336.727 37752.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32ab9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4786aa"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M11.512,6.055L11.512,6.055l0.01,0.003C11.519,6.058,11.516,6.057,11.512,6.055L11.512,6.055z M11.951,0L7.032,4.829v0.064l3.245,1.383c0.213-0.177,0.489-0.284,0.791-0.284l0.048,0.001h-0.002c0.139,0.001,0.272,0.023,0.398,0.063L12,5.292V0.049L11.951,0L11.951,0z"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: -1830.001,
    x2: -1829.001,
    y1: -1809.527,
    y2: -1809.527,
    gradientTransform: "matrix(0 20.6284 20.6284 0 37337.79 37752.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32ab9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4786aa"
  }))), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#t)",
    points: "8.351 14.309 8.268 14.446 12 19.853 12 15.06 8.351 14.309"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetlify);
export default __webpack_public_path__ + "static/media/netlify.050b8d082d9ee2c39e36ac3284acbacb.svg";
export { ForwardRef as ReactComponent };